module.exports = __webpack_public_path__ + "static/media/71.e60a4787.jpg";